import { h } from "preact";

/**
 * Кнопка «Сделать заказ».
 *
 * Пропсы:
 *   onclick — колбэк () => void
 */
export function OrderButton({ onclick }) {
  return h("button", {
    type: "button",
    class: "order-button",
    onClick: onclick,
  }, "Сделать заказ");
}
